var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogofooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 30,
    viewBox: "0 0 103 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40836 13.3008L14.379 24.8594H10.2078L9.41861 23.0253H3.66905L2.8799 24.8594H0L4.97321 13.3008H9.40836ZM8.30406 20.4177L6.55152 16.3374L4.79642 20.4177H8.30406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1181 14.3857V23.2726H27.3947V25.9478H16.0596V14.3857H20.1181Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.33 15.0605V23.9474H39.6092V26.6226H28.2715V15.0605H32.33Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.38 18.4115H46.2088V27.2983H42.1502V18.4115H37.979V15.7363H50.38V18.4115Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2695 27.9731V16.4111H62.6072V18.9546H55.328V20.9204H61.9667L61.6413 23.3085H55.328V25.1426H62.6072V27.9664L51.2695 27.9731Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4274 28.6489H63.8652V17.0869H68.6668L74.1294 25.0483V17.0869H76.6916V28.6489H71.8772L66.4274 20.6876V28.6489Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9762 20.4388H85.805V29.3257H81.7464V20.4388H77.5752V17.7637H89.9762V20.4388Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0192 18.4375L103 29.9995H98.8186L98.0294 28.1654H92.2799L91.4907 29.9995H88.6108L93.584 18.4375H98.0192ZM96.9149 25.5544L95.1624 21.4775L93.4073 25.5544H96.9149Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63682 9.77766C5.4754 8.62247 25.8627 -1.6864 51.5692 0.238914C74.8851 1.98183 98.734 13.4932 98.3496 16.1346C98.2907 16.5467 97.645 16.7155 97.1813 16.8101C86.4636 19.0293 55.8711 7.24773 51.4462 5.6433C26.7749 -3.2942 5.78542 10.9599 5.63682 9.77766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofooter);
export default __webpack_public_path__ + "static/media/logofooter.9d92bf511d40a8bc6fa799ca063548d3.svg";
export { ForwardRef as ReactComponent };